import { useContext, useEffect, useState } from "react";
import ServiceProvider from "../../models/serviceProvider";
import { useNavigate } from "react-router-dom";
import serviceProviderService from "../../services/serviceProviderService";
import SubscriptionContextModel from "../../contexts/subscriptionContextModel";
import SubscriptionContext from "../../contexts/subscriptionContext";
import Address from "../../models/address";
import ServiceProviderLink from "../../components/work/ServiceProviderLink";
import Page from "../../components/work/layout/Page";
import SearchBar from "../../components/work/layout/SearchBar";

const ServiceProviders: React.FC = () => {
  const navigate = useNavigate();

  const { subscription } =
    useContext<SubscriptionContextModel>(SubscriptionContext);

  const [serviceProviders, setServiceProviders] = useState<ServiceProvider[]>(
    [],
  );
  const [allServiceProviders, setAllServiceProviders] = useState<
    ServiceProvider[]
  >([]);
  const [serviceProviderSearch, setServiceProviderSearch] =
    useState<string>("");

  useEffect(() => {
    const init = async () => {
      try {
        const { data: serviceProviders } =
          await serviceProviderService.getServiceProviders(
            subscription.idSubscription,
          );
        setServiceProviders(serviceProviders);
        setAllServiceProviders(serviceProviders);
      } catch (error) {
        // TODO: show error with toastr
      }
    };

    init();
  }, [subscription]);

  const onSearchChange = (event: any) => {
    setServiceProviderSearch(event.target.value);
    const searchToken = event.target.value.toLowerCase();
    const newServiceProviders = allServiceProviders.filter(
      (a) => a.serviceProviderName.toLowerCase().includes(searchToken), //||
      //a.onSitePropertyManager.toLowerCase().includes(searchToken)
    );
    setServiceProviders(newServiceProviders);
  };

  const onCreateServiceProviderClick = () => {
    navigate("/work/service-providers/new");
  };

  const onEditClick = (serviceProviders: ServiceProvider) => {
    navigate(`/work/service-providers/${serviceProviders.idServiceProvider}`);
  };

  const onViewClick = (serviceProviders: ServiceProvider) => {
    navigate(
      `/work/service-provider-view/${serviceProviders.idServiceProvider}`,
    );
  };

  return (
    <Page
      pageTitle="Service Providers"
      breadcrumbs={[{ linkName: "Service Providers", linkUlr: "" }]}
    >
      <section className="section">
        <div className="card">
          {/* <div className="card-header">
            <div className="d-flex align-items-center">
              <form className="search-form">
                <i className="bi bi-search search-icon"></i>
                <input
                  type="search"
                  name="q"
                  placeholder="Search service providers..."
                  autoComplete="off"
                  value={serviceProviderSearch}
                  onChange={onSearchChange}
                />
              </form>
            </div>
            <div className="d-flex flex-column align-items-end">
              {subscription.canCreateServiceProviders && (
                <>
                  <button
                    className="btn btn-primary"
                    onClick={() => onCreateServiceProviderClick()}
                  >
                    <i className="bi bi-plus-lg me-1"></i> Create Service
                    Provider
                  </button>
                </>
              )}
              <div
                style={{
                  visibility:
                    serviceProviders.length > 0 ? "visible" : "hidden",
                }}
              >{`${serviceProviders.length} service providers`}</div>
            </div>            
          </div> */}

          <SearchBar
            placeHolderText="Search service providers..."
            searchValue={serviceProviderSearch}
            onSearchChange={onSearchChange}
            hasCreate={subscription.canCreateServiceProviders}
            createTitle="Create Service Provider"
            onCreate={() => onCreateServiceProviderClick()}
            count={serviceProviders.length}
            countType="service providers"
          />

          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover table-responsive">
                <thead>
                  <tr>
                    <th scope="col">Service Provider</th>
                    <th scope="col">Is Maintenance Company</th>
                    <th scope="col">Address</th>
                    <th scope="col">City</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Email</th>
                    <th scope="col">Contact Person</th>
                    <th scope="col">Trades</th>
                    <th style={{ width: "50px" }} />
                    <th style={{ width: "50px" }} />
                  </tr>
                </thead>
                <tbody>
                  {serviceProviders.map((serviceProvider: ServiceProvider) => (
                    <tr key={serviceProvider.idServiceProvider.toString()}>
                      <td>
                        <ServiceProviderLink
                          serviceProvider={serviceProvider}
                        />
                      </td>
                      <td>
                        {serviceProvider.isMaintenanceCompany
                          ? "True"
                          : "False"}
                      </td>
                      <td>{Address.toString(serviceProvider.address)}</td>
                      <td>{serviceProvider.address?.city}</td>
                      <td>{serviceProvider.phone}</td>
                      <td>{serviceProvider.email}</td>
                      <td>{serviceProvider.contactPersonName}</td>
                      <td>{ServiceProvider.tradesToString(serviceProvider)}</td>
                      <td>
                        <i
                          className="ri-pencil-fill"
                          style={{ fontSize: "20px", cursor: "pointer" }}
                          onClick={() => onEditClick(serviceProvider)}
                        ></i>
                      </td>
                      <td>
                        <i
                          className="bi-eye-fill"
                          style={{ fontSize: "20px", cursor: "pointer" }}
                          onClick={() => onViewClick(serviceProvider)}
                        ></i>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default ServiceProviders;
